import CaseStudyCard from "../../reusables/CaseStudyCard";
import sda from "../../../assets/images/case-studies/sda.jpg";

const SdaCaseStudyCard = () => {
  return (
    <CaseStudyCard
      brand={sda}
      client="single dollar appeal"
      solution="website design"
      title="Digital presence setup of an innovative Uganda-based NGO & Tour Company"
      subtitle="This NGO wanted to build its credibility and they needed a website and social media presence"
      link="https://singledollarappeal.org"
    >
      <li>
        ✔︎ <span>Logo design</span>
      </li>
      <li>
        ✔︎ <span>Professional Emails</span>
      </li>
      <li>
        ✔︎ <span>Social media setup</span>
      </li>
      <li>
        ✔︎ <span>Website development</span>
      </li>
      <li>
        ✔︎ <span>Google business profile</span>
      </li>
    </CaseStudyCard>
  );
};

export default SdaCaseStudyCard;
